import { render, staticRenderFns } from "./in-salabam-monographic-slider.vue?vue&type=template&id=64c86322&"
import script from "./in-salabam-monographic-slider.vue?vue&type=script&lang=js&"
export * from "./in-salabam-monographic-slider.vue?vue&type=script&lang=js&"
import style0 from "./in-salabam-monographic-slider.vue?vue&type=style&index=0&id=64c86322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports